// extracted by mini-css-extract-plugin
export var aboveInput = "_la-0";
export var actionButton = "_la-5";
export var actionButtonContainer = "_la-1";
export var actionIcon = "_la-6";
export var aiInfoContainer = "_la-2";
export var attachmentWrapper = "_la-7";
export var bold = "_la-3";
export var checkIcon = "_la-8";
export var clickingRecipientBar = "_la-11";
export var commentThreadSwitch = "_la-a";
export var draftImage = "_la-b";
export var draftImageContainer = "_la-c";
export var draftImages = "_la-e";
export var editButton = "_la-g";
export var editor = "_la-f";
export var editorContainer = "_la-y";
export var editorErrorTooltipWrapper = "_la-9";
export var headerDivider = "_la-h";
export var icon = "_la-i";
export var info = "_la-j";
export var internal = "_la-n";
export var internalDivider = "_la-k";
export var internalMessage = "_la-l";
export var messageInputCard = "_la-m";
export var messageInputForm = "_la-o";
export var messageInputFormInternal = "_la-p";
export var options = "_la-q";
export var publicMessageCustomer = "_la-s";
export var publicMessageMerchant = "_la-r";
export var removeImageButton = "_la-d";
export var replyButtons = "_la-t";
export var showSignatureButton = "_la-u";
export var spinner = "_la-v";
export var verticalButtonDivider = "_la-4";
export var visibilitySelector = "_la-w";
export var warning = "_la-x";
export var wrappingText = "_la-z";
export var writingInternalNoteTopBorder = "_la-10";